import { RootState } from '../../redux/store';
import { BadgesListState } from './BadgesListState';

export const selectBadgesListState = (state: RootState): BadgesListState => state.menuBuilder.badgesList;
